import * as Factory from 'factory.ts'

import { EntityFactory } from '@webapp/core/utils/mocks/EntityFactory'
import {
  PermissionCategory,
  type PermissionCategoryConstructor,
} from './PermissionCategory'
import {
  GeneralPermissionCategories,
  PermissionTiers,
  Permissions,
} from '../enums'

export const PermissionCategoryConstructorFactory =
  Factory.Sync.makeFactory<PermissionCategoryConstructor>({
    id: GeneralPermissionCategories.APPROVE,
    requiredPermission: null,
    permissions: [
      {
        id: 1,
        key: Permissions.APPROVE_ORDER,
        tier: PermissionTiers.PRO,
        canAssignToPrimaryCategories: false,
        canAssignToSecondaryCategories: false,
      },
      {
        id: 2,
        key: Permissions.APPROVE_EXPENSEREPORT,
        tier: PermissionTiers.PRO,
        canAssignToPrimaryCategories: true,
        canAssignToSecondaryCategories: false,
      },
      {
        id: 3,
        key: Permissions.APPROVE_TRAVEL,
        tier: PermissionTiers.PRO,
        canAssignToPrimaryCategories: true,
        canAssignToSecondaryCategories: false,
      },
    ],
  })

export const PermissionCategoryFactory = EntityFactory(
  PermissionCategory,
  PermissionCategoryConstructorFactory
)
